import { render, staticRenderFns } from "./ComponentIngredients.vue?vue&type=template&id=0901f6bd&"
import script from "./ComponentIngredients.vue?vue&type=script&lang=js&"
export * from "./ComponentIngredients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports